module.exports = __webpack_public_path__ + "img/border_angle_braces.08dce5e2.svg";